const defaultNames = [
  "Thunder Strike",
  "Lightning Bolt",
  "Midnight Runner",
  "Golden Arrow",
  "Storm Chaser",
  "Fire Spirit",
  "Wind Walker",
  "Star Dancer",
  "Silver Bullet",
  "Dark Knight",
  "Blazing Fury",
  "Swift Shadow",
  "Royal Crown",
  "Wild Thunder",
  "Dream Catcher",
  "Iron Will",
  "Brave Heart",
  "Speed Demon",
  "Noble Quest",
  "Mystic Moon",
  "Crimson Flash",
  "Desert Storm",
  "Ocean Breeze",
  "Mountain King",
  "Phoenix Rising",
];

export default defaultNames;
